//frontend/src/pages/history/historystages/AncientCivilisations.jsx
import React from 'react';
import JourneyPage from '../../../components/SubjectsPage';
import historyImage from '../../../assets/history/Classical_Antiquity_-_Han_Dynasty_China.png';

const subTopics = [
  { name: 'Mesopotamia', route: '/History-Ancient-Mesopotamia', key: 'Mesopotamia' },
  { name: 'Ancient Egypt', route: '/History-Ancient-Egypt', key: 'Ancient Egypt' },
  { name: 'Indus Valley', route: '/History-Ancient-Indusvalley', key: 'Indus Valley' },
  { name: 'Ancient China', route: '/History-Ancient-China', key: 'Ancient China' },
  { name: 'Mesoamerica', route: '/History-Ancient-Mesoamerica', key: 'Mesoamerica' }
];

function HistoryPageAC2() {
  return (
    <JourneyPage
      title="The Ancients"
      backgroundImage={historyImage}
      subTopics={subTopics}
      backRoute="/history2"
      chapterFooter=""
    />
  );
}

export default HistoryPageAC2;
